import React from "react";
import {css} from "@emotion/react";
import classNames from "classnames";

import {calculateRemSize, mb} from "@pg-design/helpers-css-strings";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {PreferencesAction} from "../../analytics/events";
import {ConfiguratorCheckboxType} from "../../types/ConfiguratorCheckboxType";
import {trackCheckbox} from "../../utils/track_checkbox";
import {ConfiguratorCheckbox} from "./ConfiguratorCheckbox";

interface IProps {
    checkboxList: ConfiguratorCheckboxType[];
    gtmAction: PreferencesAction;
    header?: string;
    isOnSidebar?: boolean;
    checkboxesWrapperClassName?: string;
    segmentWrapperClassName?: string;
}

export const ConfiguratorCheckboxes = (props: IProps) => {
    const onToggle = (checked: boolean, label: string) => {
        trackCheckbox(checked, label, props.gtmAction, props.isOnSidebar);
    };

    return (
        <div className={classNames(props.segmentWrapperClassName)} css={sectionWrapper}>
            {props.header && (
                <Text color={getThemeVariable("colors.gray.700")} css={textStyle} variant={props.isOnSidebar ? "body_copy_1" : "body_copy_0"}>
                    {props.header}
                </Text>
            )}
            <div className={classNames(props.checkboxesWrapperClassName)}>
                {props.checkboxList.map((checkbox) => (
                    <ConfiguratorCheckbox
                        key={checkbox.label}
                        label={checkbox.label}
                        icon={checkbox.icon}
                        name={checkbox.name}
                        value={checkbox.value}
                        narrow={checkbox.narrow}
                        onToggle={onToggle}
                    />
                ))}
            </div>
        </div>
    );
};

const textStyle = css`
    ${mb(1)};
`;

const sectionWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: normal;
    justify-content: normal;
    gap: ${calculateRemSize(1)};
    width: 100%;
`;
import React from "react";
import {css} from "@emotion/react";
import classNames from "classnames";

import {calculateRemSize, mb} from "@pg-design/helpers-css-strings";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {PreferencesAction} from "../../analytics/events";
import {ConfiguratorCheckboxType} from "../../types/ConfiguratorCheckboxType";
import {trackCheckbox} from "../../utils/track_checkbox";
import {ConfiguratorCheckbox} from "./ConfiguratorCheckbox";

interface IProps {
    checkboxList: ConfiguratorCheckboxType[];
    gtmAction: PreferencesAction;
    header?: string;
    isOnSidebar?: boolean;
    checkboxesWrapperClassName?: string;
    segmentWrapperClassName?: string;
}

export const ConfiguratorCheckboxes = (props: IProps) => {
    const onToggle = (checked: boolean, label: string) => {
        trackCheckbox(checked, label, props.gtmAction, props.isOnSidebar);
    };

    return (
        <div className={classNames(props.segmentWrapperClassName)} css={sectionWrapper}>
            {props.header && (
                <Text color={getThemeVariable("colors.gray.700")} css={textStyle} variant={props.isOnSidebar ? "body_copy_1" : "body_copy_0"}>
                    {props.header}
                </Text>
            )}
            <div className={classNames(props.checkboxesWrapperClassName)}>
                {props.checkboxList.map((checkbox) => (
                    <ConfiguratorCheckbox
                        key={checkbox.label}
                        label={checkbox.label}
                        icon={checkbox.icon}
                        name={checkbox.name}
                        value={checkbox.value}
                        narrow={checkbox.narrow}
                        onToggle={onToggle}
                    />
                ))}
            </div>
        </div>
    );
};

const textStyle = css`
    ${mb(1)};
`;

const sectionWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: normal;
    justify-content: normal;
    gap: ${calculateRemSize(1)};
    width: 100%;
`;
